import _indexOf from 'lodash/indexOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateFolderToMoveTo } from 'actions/videosDashboard';

import './styles.less';

const PADDING_LEFT = 24;

const GridCell = class extends Component {
  render() {
    const {
      closeFolder,
      checkedFolderIds,
      doNotRecurse,
      folder,
      folderToMoveTo,
      generateChildren,
      level,
      openedFolderIds,
      openFolder,
    } = this.props;

    const { id, name, local_id: localId } = folder.folder;

    const hasChildren = folder.children.length > 0;
    const isChecked = _indexOf(checkedFolderIds, id) > -1;
    const isSelected =
      localId != null
        ? folderToMoveTo.local_id === localId
        : folderToMoveTo.id === id;
    const isOpened = _indexOf(openedFolderIds, id) > -1;

    if (isChecked) {
      return null;
    }

    let controlIcon;
    let childGridCells;

    if (hasChildren && isOpened && !doNotRecurse) {
      controlIcon = (
        <div className="minus-icon" onClick={e => closeFolder(e, id)} />
      );

      childGridCells = generateChildren(
        folder.children,
        checkedFolderIds,
        level + 1
      );
    } else if (hasChildren && !isOpened && !doNotRecurse) {
      controlIcon = (
        <div className="plus-icon" onClick={e => openFolder(e, id)} />
      );
    }

    const style = { paddingLeft: `${PADDING_LEFT * level}px` };

    return (
      <div className="parent-cell-container" key={id}>
        <div
          className={`grid-cell ${isSelected ? 'selected' : ''}`}
          onClick={this.select.bind(this, folder.folder)}
          style={style}
        >
          <div className="cell-info">
            {controlIcon}
            <div className="name">{name}</div>
          </div>
        </div>
        {childGridCells}
      </div>
    );
  }

  select(folder) {
    const { folderToMoveTo } = this.props;

    if (folderToMoveTo.id === folder.id) {
      return;
    }

    this.props.updateFolderToMoveTo(folder);
  }
};

const mapStateToProps = state => {
  const { folder_to_move_to: folderToMoveTo } = state.videos_dashboard;

  return { folderToMoveTo };
};

const mapDispatchToProps = dispatch => {
  return {
    updateFolderToMoveTo: folder => dispatch(updateFolderToMoveTo(folder)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GridCell);
